import type { SelectOption } from "@/types/SelectOption.ts";

export const caseStatuses: SelectOption[] = [
    { id: "Case Details", label: "Case Details" },
    { id: "Liability", label: "Liability" },
    { id: "UM/UIM", label: "UM/UIM" },
    { id: "Providers", label: "Providers" },
    { id: "Loan", label: "Loan" },
    { id: "Negotiation", label: "Negotiation" },
    { id: "Disbursements", label: "Disbursements" },
    { id: "General Media", label: "General Media" },
];
